import '@babel/polyfill'
import 'url-polyfill'

import React, {StrictMode} from 'react'
import ReactDOM from 'react-dom'

import App from './components/App/App'

import 'normalize.css'
import './styles/reset.css'
import './styles/fonts.css'
import '@toasttab/buffet-styles/src/index.css'

const root = document.getElementById('root')

ReactDOM.render((
  <StrictMode>
    <App />
  </StrictMode>
), root)
